import { Injectable } from '@angular/core';
import {DataService} from "../../../../services/external-api/data.service";
import {Observable} from "rxjs";
import {emptyImportConnection,  emptyImportTpf, IImportConnection, IImportTpf} from "@retail-data-factory/rdf-angular-types-api";
import {IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {map} from "rxjs/operators";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";

@Injectable({
  providedIn: 'root'
})
export class ApiImportService {

  constructor(
    private dataService: DataService,
    private configurationManager: ConfigurationManager) { }

  /**
   * Получить список описаний соединений с источником данных
   */
  getConnections():Observable<Array<IImportConnection>>{
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiImportUrl')}/system`, {}).pipe(
      map((result:IServiceResponse)=>{
          return result.report.map(t=>this.mapImportConnectionFromService(t));
        }
      )
    );
  }

  /**
   * Получить описание соединения с источником данных по ID
   * @param id
   */
  getConnection(id: string):Observable<IImportConnection> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiImportUrl')}/system/${id}`, {}).pipe(
      map((result:IServiceResponse)=>{
          if (result.report.length) {
            return this.mapImportConnectionFromService(result.report[0]);
          }else {
            return {...emptyImportConnection};
          }
        }
      )
    );
  }

  /**
   * Создать описание соединения с источником данных
   * @param connection
   */
  createConnection(connection: IImportConnection):Observable<IServiceResponse> {
    const body = this.mapImportConnectionToService(connection);

    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiImportUrl')}/system`, {}, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  /**
   * Обновить описание соединения с источником данных
   * @param connection
   */
  updateConnection(connection: IImportConnection):Observable<IServiceResponse> {
    const body = this.mapImportConnectionToService(connection);
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiImportUrl')}/system/${connection.id}`, {}, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  /**
   * Удалить описание соединения с источником данных
   * @param id
   */
  deleteConnection(id: string):Observable<IServiceResponse> {
    return this.dataService.deleteData(`${this.configurationManager.getApiUrl('apiImportUrl')}/system/${id}`, {}, null).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }


  /**
   * Получить список описаний ETL
   */
  getTpfs():Observable<Array<IImportTpf>>{
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiImportUrl')}/tpf`, {}).pipe(
      map((result:IServiceResponse)=>{
          return result.report.map(t=>this.mapImportTpfFromService(t));
        }
      )
    );
  }

  /**
   * Получить описание ETL по ID
   * @param id
   */
  getTpf(id: string):Observable<IImportTpf> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiImportUrl')}/t[f/${id}`, {}).pipe(
      map((result:IServiceResponse)=>{
          if (result.report.length) {
            return this.mapImportTpfFromService(result.report[0]);
          }else {
            return {...emptyImportTpf};
          }
        }
      )
    );
  }

  /**
   * Создать новое описание ETL
   * @param tpf
   */
  createTpf(tpf: IImportTpf):Observable<IServiceResponse> {
    const body = this.mapImportTpfToService(tpf);

    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiImportUrl')}/tpf`, {}, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  /**
   * Обновить описание ETL
   * @param tpf
   */
  updateTpf(tpf: IImportTpf):Observable<IServiceResponse> {
    const body = this.mapImportTpfToService(tpf);
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiImportUrl')}/tpf/${tpf.id}`, {}, body).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  /**
   * Удалить описание ETL
   * @param id
   */
  deleteTpfn(id: string):Observable<IServiceResponse> {
    return this.dataService.deleteData(`${this.configurationManager.getApiUrl('apiImportUrl')}/tpf/${id}`, {}, null).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }



  private mapImportConnectionFromService(item: object):IImportConnection{
    const result:IImportConnection = {
      ...emptyImportConnection,
      id: item['id'],
      code: item['system_code'],
      description: item['system_description'],
      ip: item['ip'],
      jdbcUrl: item['jdbc_url'],
      type: item['machine_type']

    };
    return result;
  }

  private mapImportConnectionToService(connection: IImportConnection):object {
    const result = {
      system_code: connection.code,
      system_description: connection.description,
      ip: connection.ip,
      jdbc_url: connection.jdbcUrl,
      machine_type: connection.type
    };
    return result;
  }
  private mapImportTpfFromService(item: object):IImportTpf{
    const result:IImportTpf = {
      ...emptyImportTpf,
      id: item['id'],
      code: item['table_code'],
      description: item['table_description'],
      selectSql: item['select_sql'],
      prepareSql: item['prepare_sql'],
      postSql: item['post_sql']
    };
    return result;
  }

  private mapImportTpfToService(tpf: IImportTpf):object {
    const result = {
      table_code: tpf.code,
      table_description: tpf.description,
      select_sql: tpf.selectSql,
      prepare_sql: tpf.prepareSql,
      post_sql: tpf.postSql
    };
    return result;
  }

}
